const infoKindConsts = {
    "kinds": [
        "お知らせ", "障害情報"
    ],
    "getInfoKind": function (index :number){
        return this.kinds[index];
    }
}
export default infoKindConsts;
